import type { WorkOrder } from '@/types/models';
import { WorkOrderPriority } from '@/types/models';

export function getWorkOrderPriorityRank(priority: WorkOrder['priority'] | null | undefined): number {
	switch (priority) {
		case WorkOrderPriority.Urgent:
			return 0;
		case WorkOrderPriority.High:
			return 1;
		default:
			return 2;
	}
}

export function compareWorkOrdersByPriorityThen(
	a: WorkOrder,
	b: WorkOrder,
	compareWithinTier: (a: WorkOrder, b: WorkOrder) => number,
): number {
	const priorityDiff = getWorkOrderPriorityRank(a.priority) - getWorkOrderPriorityRank(b.priority);
	if (priorityDiff !== 0) return priorityDiff;
	return compareWithinTier(a, b);
}


